import React from 'react';
import TableComponent from '../components/TableComponent';
import { SurveyContext } from '../SurveyContext';

class TableDisplay extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rowsPerPage: 10,
            page: this.props.page || 0,
        };
    }

    updateState = (value, state) => {
        this.setState({
            [state]: value
        })
    }

    onRowClick = (data) => {
        const { onRowClick } = this.props;
        onRowClick(data);
    }

    addNewRow = (payload) => {
        const { addNewRow } = this.props;
        addNewRow(payload);
    };

    render() {
        const { page, rowsPerPage } = this.state;
        const { tableHeaders,  tableFields, data, type, onEditClick } = this.props;

        return (
            <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                <div style={{ width: '95%' }}>
                    <TableComponent
                        data={data}
                        headers={tableHeaders}
                        fields={tableFields}
                        updateState={this.updateState}
                        onRowClick={this.onRowClick}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        count={data.length}
                        type={type}
                        handleEditClick={onEditClick}
                    />
                </div>
            </div>
        )
    }
}

TableDisplay.contextType = SurveyContext;

export default TableDisplay;

